import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { showcontentComponent } from './showcontent.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { SubHeaderModule } from './common/sub-header/sub-header.module';
import { A11yModule } from '@angular/cdk/a11y';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';

@NgModule({
  declarations: [showcontentComponent],
  imports: [TranslateModule, CommonModule, FormsModule, ScrollPanelModule, A11yModule, SubHeaderModule],
  exports: [showcontentComponent]
})
export class showcontentModule { }
